import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from 'react-router-dom'

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
      {
        id: 7,
        title: 'About',
        link: '/about',      
    },
    {
        id: 3,       
        title: 'CUSTOMERS & AGENTS',
        link: '/sign_in',
    },
    {
        id: 6,
        title: 'BUSINESSES & AGENTS',
        link: '/work-with-tcuk',
    },
    {
        id: 7,
        title: 'ACTIVE RETAILERS',
        link: '/active-retailers',
    },
    {
        id: 90,
        title: 'TCUK UK Wallets',
        link: '/tuck-units',
    },
    // {
    //     id: 120,
    //     title: 'AUCTIONS/SALES',
    //     link: '/auctions-sales',
    //     submenu: [
    //         {
    //             title: 'TCUK Retail Auctions',
    //             link: '/auctions-sales/retail-auctions',
    //         },
    //         {
    //             title: 'TCUK Property Auctions',
    //             link: '/auctions-sales/property-auctions',
    //         },
    //         {
    //             title: 'TCUK Car Auctions',
    //             link: '/auctions-sales/car-auctions',
    //         },
    //         {
    //             title: 'TCUK Property Sales',
    //             link: '/auctions-sales/property-sales',
    //         },
    //         {
    //             title: 'TCUK Car Sales',
    //             link: '/auctions-sales/car-sales',
    //         },
    //     ],
    // },   
    {
        id: 89,
        title: 'Captain TC Cards',
        link: '/captain-tc-cards',
    },
  
]
const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="mobail-menu main_menu_list unordered_list text-uppercase">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'} style={{ marginTop: '4px' }}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="menu-item menu-item-has-children active">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <NavLink onClick={ClickHandler} className="active" style={{fontSize: '15px'}}
                                                            to={submenu.link}>{submenu.title}</NavLink>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                    
                                </Collapse>
                            </Fragment>
                            : <NavLink className="active"
                                to={item.link}>{item.title}</NavLink>
                        }
                    </ListItem>
                )
            })}                   
        </ul>
    )
}

export default MobileMenu;